import { ToastService } from '@philips-internal/oswald-ui-components';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { foundationContext } from '@philips-internal/oswald-ui-foundation';

import { Endpoint } from '../constants/endpoints';

interface ReportGenerateResponse {
  body?: { uri: string; };
}

export interface UriResponse {
  body?: {
    fileContent: string;
    contentType: string;
    contentDisposition: string;
  };
}

class ReportService {

  openInNewWindow(url: string): void {
    const win = window.open(url, '_blank');
    win && win.focus();
  }

  static async generateReport(documentNumber: string): Promise<void> {
    const body = {
      parameters: {
        CD_ESTABELECIMENTO: foundationContext.getEstablishment()?.id,
        NR_SEQ_APROVACAO: documentNumber,
      },
    };

    try {
      const response: ReportGenerateResponse = await HttpService.post(Endpoint.APPROVAL_REPORTS.replace(':documentNumber', documentNumber), {}, { body });
      const uriResponses: UriResponse = await HttpService.get(Endpoint.APPROVAL_FILE_URI, { uri: response.body?.uri });

      if (uriResponses.body) {
        const byteArray = this.base64ToBytes(uriResponses.body.fileContent);
        this.downloadFile(byteArray, foundationContext.getUser()?.username + '_' + documentNumber + '_report.pdf');
      }

    } catch (error) {
      this.handlerError(error);
    }
  }

  static base64ToBytes(base64: string): Uint8Array {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    return new Uint8Array(byteNumbers);
  }

  static downloadFile(byteArray: Uint8Array, filename: string): void {
    const blob = new Blob([byteArray]);
    const fileURL = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = filename;
    link.click();
  }

  static handlerError(error: any): { [key: string]: any; } {
    let errorMessage = 'Error.';
    if (error && error.body && error.body.errors) {
      errorMessage = error.body.errors.toString();
    }
    ToastService.open({
      id: 'approval-disapprove-toast',
      dismissible: false,
      message: errorMessage,
      level: ToastLevel.ERROR,
      timeout: 5000,
    });
    return { error: errorMessage };
  }

}
export default ReportService;
